import { apiClient } from '@/lib/api/client';
export const activitiesApi = {
    async list(groupId) {
        const { data } = await apiClient.get(`/api/v1/groups/${groupId}/activities`, {
            headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' },
        });
        return data ?? [];
    },
    async create(groupId, dto) {
        const { data } = await apiClient.post(`/api/v1/groups/${groupId}/activities`, dto);
        return data;
    },
    async update(groupId, id, dto) {
        const { data } = await apiClient.patch(`/api/v1/groups/${groupId}/activities/${id}`, dto);
        return data;
    },
    async delete(groupId, id) {
        await apiClient.delete(`/api/v1/groups/${groupId}/activities/${id}`);
    },
};
//# sourceMappingURL=activities.js.map